<template>
  <div class="app">
    <el-form :model="formData" label-width="100px">
      <el-form-item label="薪资项目：">
        <el-input v-model="name" style="width: 90%" placeholder="住宿补贴" disabled/>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input
            v-model="formData.remark"
            style="width: 90%"
            :autosize="{ minRows: 3, maxRows: 6 }"
            type="textarea"
        />
      </el-form-item>
      <h4 style="margin-left: 20px">发放规则：</h4>
      <el-form-item required
          label="金额(元/月)："
          label-width="270px"
          class="bordered-container"
      >
        <el-input-number
            v-model="formData.fullAmount"
            :precision="2"
            style="width: 50%;"
            min="0"
            controls-position="right"
        ></el-input-number>
      </el-form-item>
      <h4 style="margin-left: 20px">发放条件：</h4>
      <el-form-item required
          label="正班迟到早退请假总时间(小时/月)≤："
          label-width="270px"
          class="bordered-container"
      >
        <el-input-number
            v-model="formData.totalLeaveTime"
            style="width: 50%;"
            min="0"
            controls-position="right"
        ></el-input-number>
      </el-form-item>
      <div style="margin-top: 15%;text-align: center ">
        <el-button type="primary" @click="saveButton">保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "HousingSubsidy",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      name: '',
      formData: {
        fullAmount: '',
        totalLeaveTime: '',
        remark: ''
      },
      type: 3,
    };
  },
  methods: {
    async saveButton() {
      if (!this.formData.fullAmount){
        this.$message({
          message:'金额不能为空',
          type:'error'
        })
        return;
      }
      const params = {
        ...this.formData,
        itemId: this.parentData.id,
        type: this.type
      };
      await this.$http("salaryRuleConfigureService.saveHousingSubsidy", params);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    async getData() {
      if (this.parentData.id) {
        const data = await this.$http("salaryRuleConfigureService.getHousingSubsidyById", {id: this.parentData.id});
        this.formData = {
          fullAmount: data.full_amount,
          totalLeaveTime: data.total_leave_time,
          remark: data.remark
        };
      }
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped lang="less">
.demo-radius .title {
  color: var(--el-text-color-regular);
  font-size: 18px;
  margin: 10px 0;
}

.bordered-container {
  border: 0.5px solid lightgrey;
  padding: 15px;
  width: 95%;
  margin: 10px;
}

.app {
  margin: 20px;
}
</style>
